import { Component, inject } from '@angular/core';
import { AddCompanyForm } from '../../../../components/admin-dashboard-component/admin-companies-component/add-company-form/add-company-form';

@Component({
  selector: 'app-add-company',
  imports: [AddCompanyForm],
  templateUrl: './add-company.html',
  styleUrl: './add-company.scss',
})
export class AddCompany {}
